module.exports = __webpack_public_path__ + "img/main_culture4.efe19a54.png";